import { render } from "./modal-confirm-delete.vue?vue&type=template&id=b4b80b2c&ts=true"
import script from "./modal-confirm-delete.vue?vue&type=script&lang=ts"
export * from "./modal-confirm-delete.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__